import { render, staticRenderFns } from "./procurementQuotationSettingsDetail.vue?vue&type=template&id=46511228&scoped=true"
import script from "./procurementQuotationSettingsDetail.vue?vue&type=script&lang=js"
export * from "./procurementQuotationSettingsDetail.vue?vue&type=script&lang=js"
import style0 from "./procurementQuotationSettingsDetail.vue?vue&type=style&index=0&id=46511228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46511228",
  null
  
)

export default component.exports